import { Result, failure, success } from '../shared'
import { TreasuryProvider } from './treasury.provider'
import { TreasuryServiceErrorCode, TreasuryFailure, TreasuryServerData, TreasuryPage } from './treasury.types'

export class TreasuryService {
  constructor(private provider: TreasuryProvider) {}

  public async getPosition(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.Position)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getRotation(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.Rotation)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getProfit(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.Profit)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getLoss(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.Loss)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getLossTrans(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.LossTrans)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getTransprate(): Promise<Result<TreasuryServerData, TreasuryFailure>> {
    try {
      const { data } = await this.provider.get(TreasuryPage.Transprate)
      return success(data)
    } catch (error) {
      return failure(TreasuryServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
